import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { saveMeal } from '../../../api/diary-service';
import refetchDiaryAndEnergy from '../../../services/refetch-queries';

const useSaveMeal = (currentDay) => {
    const [isSaving, setIsSaving] = useState(false);
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: saveMeal,
        onError: (error) => console.error('Failed to save meal:', error)
    });

    const saveMealAndSync = async (mealData) => {
        setIsSaving(true);

        try {
            const payload = { ...mealData, date: currentDay };

            await mutation.mutateAsync(payload);
            await refetchDiaryAndEnergy(queryClient, currentDay);
        } catch (error) {
            console.error('Save and sync failed:', error);
        } finally {
            setIsSaving(false);
        }
    };

    return {
        saveMeal: saveMealAndSync,
        isSaving: isSaving,
        isSuccess: mutation.isSuccess,
        isError: mutation.isError,
        error: mutation.error,
        reset: mutation.reset
    };
};

export default useSaveMeal;
